import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MusicRadar: Site = {
  id: 'musicradar',
  logo: 'svg/musicradar.svg',
  label: 'MusicRadar',
  analyticsName: 'mrd',
  hostname: 'musicradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
